import { makeAutoObservable } from 'mobx';
import { MenuItemsI, AccessItemI } from '../types';
import apiConfig from '../api/routes';

export class Access{
  constructor() {
    makeAutoObservable(this);
  }
  itemsLength = 0;
  allItems: MenuItemsI[] = [];
  noPermission = false;
  currentPageDetails: AccessItemI[] = [];
  isFetchedAccesses = false;
  isAllAccessesFetched = false;
  allAccesses : AccessItemI[] = [];
  fetchMenuItems = async () => {
    try {
      this.isAllAccessesFetched = false;
      const res = await apiConfig.authAccessService.getMenuItems();
      this.allItems = res;
      this.isAllAccessesFetched = true;
      this.noPermission = false;
    }
    catch (e) {
      if ((e as Error)?.cause === 403) {
        this.isAllAccessesFetched = true;
        this.noPermission = true;
      } else {
        this.isAllAccessesFetched = false;
      }
    }
  };

  fetchAccess = async (id: number) => {
    try {
      this.isFetchedAccesses = false;
      const res = await apiConfig.authAccessService.getAccess(id.toString());
      this.itemsLength = res.length;
      this.currentPageDetails = res;
      this.isFetchedAccesses = true;
    }
    catch (e) {
      this.isFetchedAccesses = false;
    }
  };

  fetchAllAccesses = async () => {
    try {
      this.isAllAccessesFetched = false;
      const res = await apiConfig.authAccessService.getAllAccesses();
      this.allAccesses = res;
      this.isAllAccessesFetched = true;
    }
    catch (e) {
      this.isAllAccessesFetched = false;
    }
  };
}

export const AccessStore = new Access();
